import { defaultTheme } from "react-admin";
import { deepmerge } from "@mui/utils";

const theme = deepmerge(defaultTheme, {
  palette: {
    mode: "light",
    primary: {
      main: "#2563eb", // blue-600
    },
    secondary: {
      main: "#0f172a", // slate-900
    },
    background: {
      default: "#f8fafc", // slate-50
    },
  },
  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
